
import * as React from 'react';
import InformationAlert from '../../../infrastructure/InformationAlert';

const RegisterInterestInformation = () => (
  <InformationAlert text="Please confirm your nature of interest in this IP Package" />
);

export default RegisterInterestInformation;